<template>
  <div class="p-5 pt-1">
    <div class="flex flex-row justify-between">
      <div class="flex flex-row items-center">
        <p class="font-semibold text-3xl">
          {{ this.$route.meta.title }}
        </p>
      </div>
      <div
        v-show="!isPrint"
        class="flex flex-row items-center justify-end"
      >
        <date-picker
          v-model="filter.month"
          type="month"
          value-type="MM"
          format="MMM"
          placeholder="Month"
        />
        <span class="mx-3"> - </span>
        <date-picker
          v-model="filter.years"
          type="year"
          value-type="format"
          format="YYYY"
          placeholder="Years"
        />
        <vs-button
          ref="fetchButton"
          icon="visibility"
          color="secondary"
          type="filled"
          class="button shadow-secondary mx-3 vs-con-loading__container"
          @click="fetchBargePerformanceDetail"
        />
        <div class="mx-2 divider" />
        <vs-button
          ref="downloadButton"
          color="secondary"
          type="filled"
          class="button shadow-secondary min-w-button ml-3 vs-con-loading__container"
          @click="exportToPdf"
        >
          Export PDF
        </vs-button>
      </div>
    </div>
    <div class="mt-6">
      <div class="bg-white rounded-2xl p-1">
        <div class="flex flex-wrap flex-row items-center justify-between">
          <div class="flex flex-row items-center p-8">
            <img :src="require('@/assets/shipo-icon-ship.svg')">
            <span class="text-xl text-secondary font-semibold ml-4">{{ name }}</span>
          </div>
          <div class="bg-secondary-accent rounded-2xl flex flex-col py-5 px-16">
            <span class="text-secondary text-3xl font-semibold text-center">{{ rank ? `#${rank}` : '-' }}</span>
            <span class="text-secondary text-center mt-2">Owner Rangking</span>
          </div>
        </div>
      </div>
    </div>
    <div
      v-show="!isPrint"
      class="mt-6 p-2 flex flex-row rounded-lg bg-white"
    >
      <p
        v-for="(item, index) of tabs"
        class="w-1/2 p-3 cursor-pointer text-center"
        :key="index"
        :class="{'shadow font-semibold rounded-lg bg-secondary text-white': tabActive === item.id}"
        @click="onTabChange(item)"
      >
        {{ item.name }}
      </p>
    </div>
    <div class="mt-6">
      <barge-owner
        v-show="tabActive === 1 || isPrint"
        :data="bargeOwner"
        :filter="filter"
      />
      <tug-performance
        v-show="tabActive === 2 || isPrint"
        :data="tugPerformance"
        :class="{ 'mt-6 mb-6': isPrint }"
      />
    </div>
  </div>
</template>

<script>
import html2pdf from 'html2pdf.js'
import { mapGetters } from 'vuex'

import DatePicker from '@/components/datePicker'
import { PAGE_TITLE } from '@/fixtures/Constants'
import BargeOwner from '@/views/bargePerformance/detail/bargeOwner'
import TugPerformance from '@/views/bargePerformance/detail/tugPerformance'

export default {
  metaInfo() {
    return {
      title: `${PAGE_TITLE} ${this.tabs.find(item => item.id === this.tabActive).name}`
    }
  },
  components: {
    DatePicker,
    BargeOwner,
    TugPerformance
  },
  data() {
    return {
      name: '',
      rank: null,
      filter: {
        month: this.moment().subtract(1, 'months').format('MM'),
        years: this.moment().format('YYYY')
      },
      tabActive: 1,
      tabs: [
        {
          id: 1,
          name: 'Barge Owner Performance Summary'
        },
        {
          id: 2,
          name: 'List Tug Performance'
        }
      ],
      bargeOwner: {},
      tugPerformance: [],
      isPrint: false
    }
  },
  computed: {
    ...mapGetters({
      companyId: 'BargePerformance/companyId',
      bargePerformanceDetail: 'BargePerformance/bargePerformanceDetail'
    })
  },
  watch: {
    bargePerformanceDetail: {
      handler(val) {
        if (val) {
          this.name= val.name
          this.rank= val.rank
          this.bargeOwner = val.barge_owner_performance
          this.tugPerformance = val.tug_performances
        }
      }
    }
  },
  mounted() {
    this.fetchBargePerformanceDetail()
  },
  methods: {
    async fetchBargePerformanceDetail() {
      try {
        if (!!(!!this.filter.month ^ !!this.filter.years)) {
          this.showWarningNotification(this, 'Please fill out both month and year fields')
          return
        }
        await this.$store.dispatch('BargePerformance/fetchBargePerformanceDetail', {
          id: this.$route.params.id || this.companyId,
          filter: this.filter.month && this.filter.years ? this.filter : null
        })
      } catch (e) {
        this.showFailedNotification(this, 'Failed to fetch Barge Performance detail, please try again')
      }
    },
    onTabChange(item) {
      this.tabActive = item.id
    },
    exportToPdf() {
      this.isPrint = true
      this.$nextTick(() => {
        html2pdf()
          .set({
            margin: 0,
            filename: `barge_performance_${
              this.filter.month || this.moment().subtract('1', 'months').format('MMM')
            }_${
              this.filter.years || this.moment().year()
            }.pdf`,
            image: { type: 'jpeg', quality: 1 },
            html2canvas: {
              dpi: 192,
              letterRendering: true,
              scale: 2,
              width: 1024
            },
            jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' }
          })
          .from(this.createPrintArea(this.$el))
          .save()
        this.isPrint = false
      })
    },
    createPrintArea (el){
      const parent = document.createElement('div')
      parent.style.padding = '1.75rem'
      parent.style.paddingTop = '0.75rem'
      parent.style.backgroundColor = '#F1F1FD'
      parent.style.width = '1024px'
      parent.style.height = '100%'
      parent.style.overflow = 'hidden'

      const children = el.childNodes
      children.forEach(function(item) {
        parent.appendChild(item.cloneNode(true))
      })
      return parent
    }
  }
}
</script>

<style lang="scss" scoped>
.bg-secondary-accent {
  background-color: rgba(252, 219, 208, 0.45) !important;
}

.button {
  @apply py-4 #{!important};
  @apply rounded-xl #{!important};
  @apply border-2;
  @apply font-semibold;
  @apply text-base;
  height: calc( 1rem * 10 / 3 );

  &.shadow-primary {
    -webkit-box-shadow: 0 8px 25px -8px rgba(var(--vs-primary),1);
    box-shadow: 0 8px 25px -8px rgba(var(--vs-primary),1);
  }

  &.shadow-secondary {
    -webkit-box-shadow: 0 8px 25px -8px rgba(var(--vs-secondary),1);
    box-shadow: 0 8px 25px -8px rgba(var(--vs-secondary),1);
  }

  &:focus {
    @apply outline-none;
  }
}

.divider {
  @apply h-10;

  border-left: solid 1px #DEDEDE;
}

/deep/.datepicker {
  width: 145px !important;
}

/deep/.mx-input-wrapper {
  background-color: white !important;
}
</style>
